export const COOKIES_KEY = 'cookies.cookiesAllowed';
export const APP_JWT_TOKEN = 'app.token';
